import Hero from '../components/Hero/Hero'
import Lists from '../components/Lists/Lists';

const Home = () => {
    return(
        <main>
            <Hero />
            <Lists/>
        </main>
    )
}

export default Home